"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TICKET_CHANNEL_LABELS = exports.TICKET_CHANNELS = void 0;
/**
 * Canale di provenienza di un ticket (DEC-003, DEC-005; contratto di integrazione §5.1). I valori
 * sono quelli del contratto verso i consumer e alimentano le viste di coda. Nessun canale paziente.
 */
exports.TICKET_CHANNELS = ['in-piattaforma', 'pre-accesso'];
exports.TICKET_CHANNEL_LABELS = {
    'in-piattaforma': 'In piattaforma',
    'pre-accesso': 'Pre-accesso',
};
//# sourceMappingURL=ticket-channel.js.map